// extracted by mini-css-extract-plugin
module.exports = {"message":"TaxForm_message__PeRL7","is_visible":"TaxForm_is_visible__SfRh0","fields":"TaxForm_fields__OgKFG","item":"TaxForm_item__hrY4R","submit":"TaxForm_submit__FXrru"};